import { Product } from 'src/app/models/product.model';

export function dotProduct(a: number[], b: number[]) {
  const result = a.reduce((acc, cur, index) => {
    acc += (cur * b[index]);
    return acc;
  }, 0);
  return result;
}

export function reducedPrice(product: Product) {
  return Math.max(0, product.price * (1 - (product.reduction / 100)))
}
